webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = {
  get_viewport: function get_viewport() {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
  },
  scrollTo2: function scrollTo2(element, duration) {
    var startingY = window.pageYOffset;
    var diff = window.pageYOffset + element.getBoundingClientRect().top - startingY;
    var start;
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp;
      var time = timestamp - start;
      var percent = Math.min(time / duration, 1);
      window.scrollTo(0, startingY + diff * percent);
      if (time < duration) {
        window.requestAnimationFrame(step);
      }
    });
  },
  isTouch: function isTouch() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  loadScript: function loadScript(src, id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!document.querySelector('script#' + id)) {
        var s;
        s = document.createElement('script');
        s.id = id;
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      } else {
        resolve();
      }
    });
  },
  handleArrow: function handleArrow(event) {
    event.preventDefault();
    var nextIndex = parseInt(event.target.dataset.index) + 1;
    var next = document.querySelectorAll('[data-type="layout"]')[parseInt(event.target.dataset.index)];

    var scrollBottom = function scrollBottom(element, duration) {
      var startingY = window.pageYOffset;
      var diff = element.getBoundingClientRect().bottom;
      var start;
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        window.scrollTo(0, startingY + diff * percent);
        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    };

    scrollBottom(next, 450);
  },
  addArrows: function addArrows() {
    var _this = this;

    document.querySelectorAll('[data-type="layout"] .read-more').forEach(function (item) {
      item.addEventListener('click', _this.handleArrow, true);
    });
  },
  removeArrows: function removeArrows() {
    var _this2 = this;

    document.querySelectorAll('[data-type="layout"] .read-more').forEach(function (item) {
      item.removeEventListener('click', _this2.handleArrow, true);
    });
  }
};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = {
    after: function after(field, _ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
            target = _ref2[0];

        return 'The ' + field + ' must be after ' + target + '.';
    },
    alpha_dash: function alpha_dash(field) {
        return 'The ' + field + ' may contain alpha-numeric characters as well as dashes and underscores.';
    },
    alpha_num: function alpha_num(field) {
        return 'The ' + field + ' may only contain alpha-numeric characters.';
    },
    alpha_spaces: function alpha_spaces(field) {
        return 'The ' + field + ' may only contain alphabetic characters as well as spaces.';
    },
    alpha: function alpha(field) {
        return 'The ' + field + ' may only contain alphabetic characters.';
    },
    before: function before(field, _ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
            target = _ref4[0];

        return 'The ' + field + ' must be before ' + target + '.';
    },
    between: function between(field, _ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            min = _ref6[0],
            max = _ref6[1];

        return 'The ' + field + ' must be between ' + min + ' and ' + max + '.';
    },
    confirmed: function confirmed(field) {
        return 'The ' + field + ' confirmation does not match.';
    },
    credit_card: function credit_card(field) {
        return 'The ' + field + ' is invalid.';
    },
    date_between: function date_between(field, _ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            min = _ref8[0],
            max = _ref8[1];

        return 'The ' + field + ' must be between ' + min + ' and ' + max + '.';
    },
    date_format: function date_format(field, _ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref9, 1),
            format = _ref10[0];

        return 'The ' + field + ' must be in the format ' + format + '.';
    },
    decimal: function decimal(field) {
        var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['*'],
            _ref12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref11, 1),
            decimals = _ref12[0];

        return 'The ' + field + ' must be numeric and may contain ' + (decimals === '*' ? '' : decimals) + ' decimal points.';
    },
    digits: function digits(field, _ref13) {
        var _ref14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref13, 1),
            length = _ref14[0];

        return 'The ' + field + ' must be numeric and exactly contain ' + length + ' digits.';
    },
    dimensions: function dimensions(field, _ref15) {
        var _ref16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref15, 2),
            width = _ref16[0],
            height = _ref16[1];

        return 'The ' + field + ' must be ' + width + ' pixels by ' + height + ' pixels.';
    },
    email: function email(field) {
        return 'The ' + field + ' must be a valid email.';
    },
    ext: function ext(field) {
        return 'The ' + field + ' must be a valid file.';
    },
    image: function image(field) {
        return 'The ' + field + ' must be an image.';
    },
    in: function _in(field) {
        return 'The ' + field + ' must be a valid value.';
    },
    ip: function ip(field) {
        return 'The ' + field + ' must be a valid ip address.';
    },
    max: function max(field, _ref17) {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref17, 1),
            length = _ref18[0];

        return 'The ' + field + ' may not be greater than ' + length + ' characters.';
    },
    max_value: function max_value(field, _ref19) {
        var _ref20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref19, 1),
            max = _ref20[0];

        return 'The ' + field + ' must be ' + max + ' or less.';
    },
    mimes: function mimes(field) {
        return 'The ' + field + ' must have a valid file type.';
    },
    min: function min(field, _ref21) {
        var _ref22 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref21, 1),
            length = _ref22[0];

        return 'The ' + field + ' must be at least ' + length + ' characters.';
    },
    min_value: function min_value(field, _ref23) {
        var _ref24 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref23, 1),
            min = _ref24[0];

        return 'The ' + field + ' must be ' + min + ' or more.';
    },
    not_in: function not_in(field) {
        return 'The ' + field + ' must be a valid value.';
    },
    numeric: function numeric(field) {
        return 'The ' + field + ' may only contain numeric characters.';
    },
    regex: function regex(field) {
        return 'The ' + field + ' format is invalid.';
    },
    required: function required(field) {
        return 'The ' + field + ' is required.';
    },
    size: function size(field, _ref25) {
        var _ref26 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref25, 1),
            _size = _ref26[0];

        return 'The ' + field + ' must be less than ' + _size + ' KB.';
    },
    url: function url(field) {
        return 'The ' + field + ' is not a valid URL.';
    }
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = {
    after: function after(field, _ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
            target = _ref2[0];

        return 'El campo ' + field + ' debe ser posterior a ' + target + '.';
    },
    alpha_dash: function alpha_dash(field) {
        return 'El campo ' + field + ' solo debe contener letras, n\xFAmeros y guiones.';
    },
    alpha_num: function alpha_num(field) {
        return 'El campo ' + field + ' solo debe contener letras y n\xFAmeros.';
    },
    alpha: function alpha(field) {
        return 'El campo ' + field + ' solo debe contener letras.';
    },
    before: function before(field, _ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
            target = _ref4[0];

        return 'El campo ' + field + ' debe ser anterior a ' + target + '.';
    },
    between: function between(field, _ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            min = _ref6[0],
            max = _ref6[1];

        return 'El campo ' + field + ' debe estar entre ' + min + ' y ' + max + '.';
    },
    confirmed: function confirmed(field, _ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7, 1),
            confirmedField = _ref8[0];

        return 'El campo ' + field + ' no coincide con ' + confirmedField + '.';
    },
    date_between: function date_between(field, _ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
            min = _ref10[0],
            max = _ref10[1];

        return 'El campo ' + field + ' debe estar entre ' + min + ' y ' + max + '.';
    },
    date_format: function date_format(field, _ref11) {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref11, 1),
            format = _ref12[0];

        return 'El campo ' + field + ' debe tener formato formato ' + format + '.';
    },
    decimal: function decimal(field) {
        var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['*'],
            _ref14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref13, 1),
            decimals = _ref14[0];

        return 'El campo ' + field + ' debe ser n\xFAmerico y contener ' + (decimals === '*' ? '' : decimals) + ' puntos decimales.';
    },
    digits: function digits(field, _ref15) {
        var _ref16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref15, 1),
            length = _ref16[0];

        return 'El campo ' + field + ' debe ser n\xFAmerico y contener exactamente ' + length + ' d\xEDgitos.';
    },
    dimensions: function dimensions(field, _ref17) {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
            width = _ref18[0],
            height = _ref18[1];

        return 'El campo ' + field + ' debe ser de ' + width + ' pixeles por ' + height + ' pixeles.';
    },
    email: function email(field) {
        return 'El campo ' + field + ' debe ser un correo electr\xF3nico v\xE1lido.';
    },
    ext: function ext(field) {
        return 'El campo ' + field + ' debe ser un archivo v\xE1lido.';
    },
    image: function image(field) {
        return 'El campo ' + field + ' debe ser una imagen.';
    },
    in: function _in(field) {
        return 'El campo ' + field + ' debe ser un valor v\xE1lido.';
    },
    ip: function ip(field) {
        return 'El campo ' + field + ' debe ser una direcci\xF3n ip v\xE1lida.';
    },
    max: function max(field, _ref19) {
        var _ref20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref19, 1),
            length = _ref20[0];

        return 'El campo ' + field + ' no debe ser mayor a ' + length + ' caracteres.';
    },
    mimes: function mimes(field) {
        return 'El campo ' + field + ' debe ser un tipo de archivo v\xE1lido.';
    },
    min: function min(field, _ref21) {
        var _ref22 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref21, 1),
            length = _ref22[0];

        return 'El campo ' + field + ' debe tener al menos ' + length + ' caracteres.';
    },
    not_in: function not_in(field) {
        return 'El campo ' + field + ' debe ser un valor v\xE1lido.';
    },
    numeric: function numeric(field) {
        return 'El campo ' + field + ' debe contener solo caracteres n\xFAmericos.';
    },
    regex: function regex(field) {
        return 'El formato del campo ' + field + ' no es v\xE1lido.';
    },
    required: function required(field) {
        return 'El campo ' + field + ' es obligatorio.';
    },
    size: function size(field, _ref23) {
        var _ref24 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref23, 1),
            _size = _ref24[0];

        return 'El campo ' + field + ' debe ser menor a ' + _size + ' KB.';
    },
    url: function url(field) {
        return 'El campo ' + field + ' no es una URL v\xE1lida.';
    }
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_index__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Problems__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Problems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Problems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Solutions__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Solutions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Solutions__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: 'history',
  routes: [{
    path: '/:lang',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2_components_index___default.a
  }, {
    path: '/:lang/problems',
    name: 'Problems',
    component: __WEBPACK_IMPORTED_MODULE_3_components_Problems___default.a
  }, {
    path: '/:lang/solutions',
    name: 'Solutions',
    component: __WEBPACK_IMPORTED_MODULE_4_components_Solutions___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2_components_index___default.a
  }]
});

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'swiper-slide',
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.destroyLoop();
          this.$parent.swiper.createLoop();
        }
      }
    }
  }
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(48);
  __webpack_require__(135);
}
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        self.swiper = new Swiper(self.$el, self.options);
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    this.swiper.update();
  },
  beforeDestroy: function beforeDestroy() {
    if (!!this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(142);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          return val in icons;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* warn */])('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / 112 * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / 112 * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      icons[name] = data[name];
    }
  },

  icons: icons
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    HeaderApp: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a
  },
  data: function data() {
    return {
      menuActive: false
    };
  },

  methods: {
    scrollContent: function scrollContent() {
      var offset = 60;
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach(function (item) {
        if (item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset) {
          if (item.dataset.header) document.querySelector('.header-nav').dataset.color = item.dataset.header || 'white';
        }
      });
    },
    loadGoogleAnalytics: function loadGoogleAnalytics() {
      var _this = this;

      window.location.hostname === 'plastickills.es' && __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].loadScript('https://www.google-analytics.com/analytics.js', 'googleanalytics').then(function () {
        window.ga = window.ga || function () {
          (ga.q = ga.q || []).push(arguments);
        };ga.l = +new Date();
        ga('create', 'UA-32961862-5', 'auto');
        ga('send', 'pageview');
        ga('send', {
          hitType: 'pageview',
          page: _this.$route.path,
          location: window.location.origin + _this.$route.fullPath,
          title: _this.$route.name
        });
      });
    }
  },
  created: function created() {
    if (this.$route.params.lang) {
      localStorage.setItem('language', this.$route.params.lang);
      this.$validator.setLocale(this.$route.params.lang);
    } else {
      localStorage.setItem('language', 'es');
      this.$validator.setLocale('es');
      this.$router.push({
        name: 'Index',
        params: {
          lang: 'es'
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadGoogleAnalytics();
  }
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vee_validate__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Contact',
  data: function data() {
    return {
      lang: localStorage.getItem('language') || 'en',
      isSubmitted: false,
      name: '',
      business: '',
      email: '',
      placeholder: {
        business: {
          en: 'Business',
          es: 'Empresa'
        },
        name: {
          en: 'Name',
          es: 'Nombre'
        },
        email: {
          en: 'Email',
          es: 'Email'
        },
        submit: {
          en: 'Send',
          es: 'Enviar'
        }
      },
      result: {
        success: {
          es: 'Tu mensaje ha sido enviado satisfactoriamente.',
          en: 'Thank you, we will get in touch with you soon!.'
        },
        error: {
          es: 'Hemos encontrado un error, por favor intenta nuevamente.',
          en: 'Whoops, we found some error, please try again. We hope you are a human.'
        }
      }
    };
  },

  methods: {
    inputOnFocus: function inputOnFocus(event) {
      document.querySelectorAll('#contact .field-text').forEach(function (el) {
        el.classList.remove('on-focus');
      });
      event.target.parentElement.classList.add('on-focus');
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$validator.validateAll();
      if (this.errors.any()) return false;

      this.axios.post("http://plastickills.es/site" + '/wp-json/nz-rest/v1/sendemail', {
        name: this.name,
        email: this.email,
        message: this.business
      }).then(function (response) {
        _this.isSubmitted = true;
        setTimeout(function () {
          _this.isSubmitted = false;
        }, 3000);
      });
    },
    reloadForm: function reloadForm() {
      this.lang = localStorage.getItem('language') || 'en';
      this.$validator.setLocale(localStorage.getItem('language'));
      this.errors.clear();
    }
  },
  watch: {
    '$route': 'reloadForm'
  }
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contact__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Contact__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'footer',
  components: {
    Contact: __WEBPACK_IMPORTED_MODULE_1__Contact___default.a
  },
  data: function data() {
    return {
      year: '',
      page: {},
      footer: {}
    };
  },

  watch: {
    '$route': 'getContent'
  },
  methods: {
    getPage: function getPage() {
      if (localStorage.getItem('language') === 'en') {
        return this.axios.get("http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=contact');
      } else {
        return this.axios.get("http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=contacto&lang=es');
      }
    },
    getOptions: function getOptions() {
      return this.axios.get("http://plastickills.es/site" + '/wp-json/acf/v2/options');
    },
    getContent: function getContent() {
      var _this = this;

      this.axios.all([this.getPage(), this.getOptions()]).then(this.axios.spread(function (page, options) {
        _this.footer = options.data.acf;
        _this.page = page.data[0].acf;
      }));
    },
    fadeFooterIn: function fadeFooterIn() {
      if (__WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height > 748) {
        var footer_pos_top = document.querySelector('.content-wrapper').getBoundingClientRect().bottom;
        var is_visible = __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height - footer_pos_top >= 0 ? true : false;
        var part = parseInt((__WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height - footer_pos_top) * 100 / __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height);
      } else {
        var footer_pos_top = document.querySelector('.footer-wrapper').getBoundingClientRect().top;
        var is_visible = footer_pos_top < 400 ? true : false;
        var part = parseInt((__WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height - document.querySelector('.footer-wrapper').getBoundingClientRect().top) * 100 / __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height);
      }
      if (is_visible && part > 60 && !this.$el.classList.contains('active')) {
        this.$el.classList.add('active');
      }
      if (!is_visible || part < 60) {
        this.$el.classList.remove('active');
      }
    }
  },
  created: function created() {
    this.getContent();

    var today = new Date();
    this.year = today.getFullYear();
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener('scroll', _this2.fadeFooterIn);
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.fadeFooterIn);
  }
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
	name: 'Header',
	data: function data() {
		return {
			lang: localStorage.getItem('language') || 'en',
			isMenuActive: false,
			problems: {
				es: 'Problemas',
				en: 'Problems'
			},
			solutions: {
				es: 'Soluciones',
				en: 'Solutions'
			},
			joinUs: {
				es: 'Participa',
				en: 'Join Us'
			}
		};
	},

	computed: {
		isTriggered: function isTriggered() {
			return this.isMenuActive ? 'block' : 'none';
		}
	},
	watch: {
		isMenuActive: function isMenuActive() {
			document.body.classList.toggle('menu-on');
		},
		lang: function lang() {
			localStorage.setItem('language', this.lang);
			this.$router.push({
				name: this.$route.name,
				params: {
					lang: this.lang
				}
			});
		}
	},
	methods: {
		hideMenu: function hideMenu() {
			console.log('hiding');
		},
		goFooter: function goFooter() {
			if (document.querySelector('.header-wrapper').classList.contains('active')) {
				document.querySelector('.header-wrapper .menu-trigger a').click();
			}
			setTimeout(function () {
				window.scrollTo(0, document.body.scrollHeight);
			}, 10);
		}
	}
};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'problems-plastickill-graph',
  data: function data() {
    return {
      isActive: false,
      credits: '',
      consumables: {},
      residuals: {}
    };
  },

  methods: {
    fadeLayoutIn: function fadeLayoutIn() {
      var isVisible = __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height - this.$el.getBoundingClientRect().top > 0 ? true : false;
      var part = parseInt((__WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height - this.$el.getBoundingClientRect().top) * 100 / __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().height);
      if (isVisible && part > 60 && !this.$el.classList.contains('active')) {
        this.isActive = true;
      }
      if (!isVisible) {
        this.isActive = false;
        this.$el.classList.remove('active');
      }
    },
    getUrl: function getUrl() {
      if (localStorage.getItem('language') === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problems-statistics';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problemas-estadisticas&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this = this;

      var getUrl = this.getUrl();
      window.removeEventListener('scroll', this.fadeLayoutIn);

      this.axios.get(this.getUrl()).then(function (response) {

        var page = response.data[0];
        _this.consumables = page.acf.graphs[0];
        _this.residuals = page.acf.graphs[1];
        _this.credits = page.acf.credits;

        if (_this.consumables.title && _this.residuals.title) {
          _this.$nextTick(function () {
            window.addEventListener('scroll', _this.fadeLayoutIn);
          });
        }
        _this.$nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].addArrows();
        });
      });
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.loadContent();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.fadeLayoutIn);
  }
};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_parallax_min_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_parallax_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js_parallax_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_Problems_planet_ocean_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_Problems_planet_ocean_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__js_Problems_planet_ocean_js__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'problems-ocean',
  data: function data() {
    return {
      self: this,
      title: '',
      slider: [{
        title: '',
        content: ''
      }, {
        title: '',
        content: ''
      }],
      swiperOption: {
        notNextTick: true,
        loop: true,
        updateTranslate: true,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        observeParents: true,
        debugger: true,
        speed: 600,
        autoplay: 0,
        paginationClickable: false,
        currentSlide: 0,
        onSlideChangeStart: function onSlideChangeStart(s) {
          if ('ontouchstart' in window || navigator.maxTouchPoints || __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().width < 560) {
            var activeSlideHeight = s.slides[s.activeIndex].querySelector('.full-inner').getBoundingClientRect().height + 'px';
            s.container[0].style.height = activeSlideHeight;
          }
          this.currentSlide = s.realIndex;
        }
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.problemsOcean.swiper;
    }
  },
  methods: {
    getUrl: function getUrl() {
      if (localStorage.getItem('language') === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problems-oceans';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problemas-oceanos&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this = this;

      var getUrl = this.getUrl();
      this.axios.get(this.getUrl()).then(function (response) {
        var page = response.data[0];
        _this.title = page.acf.title;
        _this.slider = page.acf.slider;
        __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].addArrows();
      });
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.loadContent();
    });

    __WEBPACK_IMPORTED_MODULE_2__js_Problems_planet_ocean_js___default.a.initBubbles();
    __WEBPACK_IMPORTED_MODULE_2__js_Problems_planet_ocean_js___default.a.parallax();
  }
};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_Problems_planet_space_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_Problems_planet_space_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__js_Problems_planet_space_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'problems-planet',
  data: function data() {
    return {
      isPopupActive: false,
      page: {},
      showArrow: true,
      popupTitle: '',
      popupText: '',
      points: []
    };
  },

  methods: {
    getUrl: function getUrl() {
      if (this.$route.params.lang === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problems-planet';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problemas-el-planeta&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this = this;

      var getUrl = this.getUrl();
      this.axios.get(this.getUrl()).then(function (response) {
        var places = response.data[0].acf.places;
        _this.page.title = response.data[0].acf.title;
        _this.points = [];
        places && places.forEach(function (el) {
          _this.points.push({
            name: el.name,
            text: el.text,
            x: parseInt(el.pos_x),
            y: parseInt(el.pos_y)
          });
        });
        _this.$nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_0__js_Problems_planet_space_js___default.a.initPoints();
          __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].addArrows();
        });
      });
    },
    pauseMarkers: function pauseMarkers(option) {
      var divs = document.querySelectorAll('.planet-markers');
      for (var i = 0; i < divs.length; i++) {
        if (option) divs[i].classList.add('paused');else divs[i].classList.remove('paused');
      }
    },
    showPopup: function showPopup(id) {
      this.pauseMarkers(true);
      this.popupTitle = this.points[id].name;
      this.popupText = this.points[id].text;
      this.isPopupActive = true;
    },
    closePopup: function closePopup() {
      this.pauseMarkers(false);
      this.isPopupActive = false;
    },
    handleArrow: function handleArrow() {
      if (document.body.scrollTop > 200) {
        this.showArrow = false;
      }
      if (document.body.scrollTop === 0) this.showArrow = true;
    },
    doArrow: function doArrow() {
      __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].scrollTo2('#swiper-ocean-container', 600);
    }
  },
  created: function created() {
    this.loadContent();
  },

  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__js_Problems_planet_space_js___default.a.initSpace();
    window.addEventListener('scroll', this.handleArrow);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleArrow);
  }
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'problems-plastickill',
  data: function data() {
    return {
      title: '',
      slider: {},
      swiperOption: {
        notNextTick: true,
        loop: true,
        updateTranslate: true,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        observeParents: true,
        debugger: true,
        speed: 600,
        autoplay: 0,
        paginationClickable: false,
        onSlideChangeStart: function onSlideChangeStart(s) {
          if ('ontouchstart' in window || navigator.maxTouchPoints || __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].get_viewport().width < 560) {
            var activeSlideHeight = s.slides[s.activeIndex].querySelector('.full-inner').getBoundingClientRect().height + 'px';
            s.container[0].style.height = activeSlideHeight;
          }
        }
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.problemsPlasticKills.swiper;
    }
  },
  methods: {
    getUrl: function getUrl() {
      if (localStorage.getItem('language') === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problems-why-plastic-kills';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=problemas-porque-el-plastico-mata&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this = this;

      var getUrl = this.getUrl();
      this.axios.get(this.getUrl()).then(function (response) {
        var page = response.data[0];
        _this.title = page.acf.title;
        _this.slider = page.acf.slider;
        __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].addArrows();
      });
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    this.loadContent();
  }
};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Problems_planet__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Problems_planet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Problems_planet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Problems_ocean__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Problems_ocean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Problems_ocean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Problems_plastickill__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Problems_plastickill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Problems_plastickill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Problems_graph__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Problems_graph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Problems_graph__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Index',
  components: {
    FooterApp: __WEBPACK_IMPORTED_MODULE_1__Footer___default.a,
    ProblemsPlanet: __WEBPACK_IMPORTED_MODULE_2__Problems_planet___default.a,
    ProblemsOcean: __WEBPACK_IMPORTED_MODULE_3__Problems_ocean___default.a,
    ProblemsPlastickill: __WEBPACK_IMPORTED_MODULE_4__Problems_plastickill___default.a,
    ProblemsGraph: __WEBPACK_IMPORTED_MODULE_5__Problems_graph___default.a
  },
  data: function data() {
    return {
      title: {
        en: 'Plastic Pollution is a Global Problem',
        es: 'El Plástico Desechable es un Problema Global'
      },
      description: {
        en: 'Plastic pollution is a problem that affects our environment, our oceans, our coasts and our health. Here’s all the info you need to know to take action!',
        es: 'La contaminación plástica es un problema que afecta a nuestro entorno, a océanos, costas, incluso a nuestra salud. Encuentra aquí toda la información y actúa!'
      }
    };
  },

  head: {
    title: function title() {
      return {
        inner: this.title[localStorage.getItem('language')]
      };
    },
    meta: function meta() {
      return [{ name: 'description', content: this.description[localStorage.getItem('language')] }, { name: 'twitter:title', content: this.title[localStorage.getItem('language')] }, { name: 'twitter:descripcion', content: this.description[localStorage.getItem('language')] }];
    },
    link: function link() {
      return [{ rel: 'canonical', href: window.location.href }];
    }
  },
  methods: {
    scrollContent: function scrollContent() {
      var offset = 60;
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach(function (item, index) {
        if (item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset) if (item.dataset.header) document.querySelector('.header-nav').dataset.color = item.dataset.header;else document.querySelector('.header-nav').dataset.color = 'white';
        if (document.querySelectorAll('.wrapper-padding-bottom .span-full').length === index + 1 && item.getBoundingClientRect().bottom < 0) {
          document.querySelector('.header-nav').dataset.color = 'white';
        }
      });
    },
    loadContent: function loadContent() {
      this.title[localStorage.getItem('language')] = this.title[localStorage.getItem('language')];
      this.description[localStorage.getItem('language')] = this.description[localStorage.getItem('language')];
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.scrollContent);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__js_scripts_js__["a" /* default */].removeArrows();
    window.removeEventListener('scroll', this.scrollContent);
  }
};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'solutions-advise',
  data: function data() {
    return {
      isDialogActive: false,
      isDialogListActive: false,
      isConfirmationActive: false,
      activeIndex: 0,
      page: {
        title: '',
        content: '',
        callToAction: ''
      },
      confirmation: {
        title: '',
        content: '',
        close: ''
      },
      dialogs: []
    };
  },

  computed: {
    activeDialog: function activeDialog() {
      return this.dialogs[this.activeIndex];
    }
  },
  methods: {
    openDialog: function openDialog() {
      var _this = this;

      this.isDialogActive = true;
      this.$nextTick(function () {
        _this.isDialogListActive = true;
      });
    },
    closeDialog: function closeDialog() {
      var _this2 = this;

      this.isDialogListActive = false;
      setTimeout(function () {
        _this2.isDialogActive = false;
      }, 300);
    },
    closeConfirmation: function closeConfirmation() {
      var _this3 = this;

      this.isConfirmationActive = false;
      setTimeout(function () {
        _this3.isDialogActive = false;
        _this3.activeIndex = 0;
      }, 600);
    },
    showNext: function showNext() {
      var _this4 = this;

      if (parseInt(this.activeIndex) + 1 < this.dialogs.length) {
        this.isDialogListActive = false;
        setTimeout(function () {
          _this4.activeIndex += 1;
        }, 400);
        setTimeout(function () {
          _this4.isDialogListActive = true;
        }, 500);
      } else {
        this.isDialogListActive = false;
        setTimeout(function () {
          _this4.isConfirmationActive = true;
        }, 1000);
      }
    },
    getUrl: function getUrl() {
      if (localStorage.getItem('language') === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=solutions-promises';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=soluciones-promesas&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this5 = this;

      var getUrl = this.getUrl();
      this.axios.get(this.getUrl()).then(function (response) {

        _this5.activeDialog = _this5.dialogs[_this5.index];


        var page = response.data[0].acf;

        _this5.page.title = page.title;
        _this5.page.content = page.description;
        _this5.page.callToAction = page.call_to_action;
        _this5.dialogs = page.promises;
        _this5.confirmation.title = page.confirmation_title;
        _this5.confirmation.content = page.confirmation_text;
        _this5.confirmation.close = page.confirmation_close;
      });
    }
  },
  watch: {
    '$route': 'loadContent',
    isDialogActive: function isDialogActive() {
      if (this.isDialogActive) {
        document.body.classList.add('dialog-active');
      } else {
        document.body.classList.remove('dialog-active');
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.loadContent();
    });
  }
};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'solution-tips',
  data: function data() {
    return {
      direction: ['vertical', 'horizontal'],
      tips: [],
      shuffled: []
    };
  },

  methods: {
    getUrl: function getUrl() {
      this.tips = [];
      if (localStorage.getItem('language') === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=solutions-tips';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=soluciones-tips&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this = this;

      var getUrl = this.getUrl();
      window.removeEventListener('scroll', this.fadeLayoutIn);

      this.axios.get(this.getUrl()).then(function (response) {
        var page = response.data[0].acf;
        _this.tips = page.tips;
      });
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.loadContent();
    });
  }
};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Solutions_promises__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Solutions_promises___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Solutions_promises__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Solutions_tips__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Solutions_tips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Solutions_tips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_scripts_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Solutions',
  components: {
    FooterApp: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a,
    SolutionsPromises: __WEBPACK_IMPORTED_MODULE_1__Solutions_promises___default.a,
    SolutionsTips: __WEBPACK_IMPORTED_MODULE_2__Solutions_tips___default.a
  },
  data: function data() {
    return {
      title: {
        en: 'The Solution Against Single-use Plastic',
        es: 'La Solución Contra el Plástico Desechable'
      },
      description: {
        en: 'There’s only one possible solution against plastic pollution. Saying NO to single-use plastic! Learn how here.',
        es: 'Solo existe una solución contra la polución plástica: dejar de consumir el plástico desechable. Aquí te enseñamos a cómo conseguirlo.'
      },
      isTouch: __WEBPACK_IMPORTED_MODULE_3__js_scripts_js__["a" /* default */].isTouch(),
      showArrow: true,
      fishSchool: [],
      fishSchoolData: [{ color: 'red', x: '10%', y: '20%' }, { color: 'blue', x: '10%', y: '50%' }, { color: 'yellow', x: '7%', y: '86%' }, { color: 'green', x: '22%', y: '55%' }, { color: 'blue', x: '25%', y: '90%' }, { color: 'blue', x: '32%', y: '16%' }, { color: 'orange', x: '33%', y: '44%' }, { color: 'green', x: '35%', y: '65%' }, { color: 'red', x: '48%', y: '8%' }, { color: 'red', x: '50%', y: '80%' }, { color: 'green', x: '52%', y: '20%' }, { color: 'orange', x: '57%', y: '24%' }, { color: 'yellow', x: '60%', y: '60%' }, { color: 'orange', x: '56%', y: '92%' }, { color: 'blue', x: '72%', y: '38%' }, { color: 'yellow', x: '80%', y: '10%' }, { color: 'orange', x: '76%', y: '64%' }, { color: 'green', x: '85%', y: '40%' }, { color: 'blue', x: '85%', y: '50%' }, { color: 'blue', x: '81%', y: '80%' }, { color: 'yellow', x: '90%', y: '20%' }]
    };
  },

  head: {
    title: function title() {
      return {
        inner: this.title[localStorage.getItem('language')]
      };
    },
    meta: function meta() {
      return [{ name: 'description', content: 'Descripcion de Soluciones' }, { name: 'twitter:title', content: this.title[localStorage.getItem('language')] }, { name: 'twitter:descripcion', content: this.description[localStorage.getItem('language')] }];
    },
    link: function link() {
      return [{ rel: 'canonical', href: window.location.href }];
    }
  },
  methods: {
    updateFishScholl: function updateFishScholl(x, y) {
      var offsetX = 50;
      var offsetY = 34;
      var i = 0;
      for (i = 0; i < this.fishSchool.length; i++) {
        var fish = this.fishSchool[i];
        var fishX = fish.offsetLeft + offsetX;
        var fishY = fish.offsetTop + offsetY;

        var deltaX = x - fishX;
        var deltaY = y - fishY;

        var deg = Math.atan2(deltaY, deltaX) * 180 / Math.PI;

        fish.style.webkitTransform = 'rotate(' + deg + 'deg)';
        fish.style.mozTransform = 'rotate(' + deg + 'deg)';
        fish.style.msTransform = 'rotate(' + deg + 'deg)';
        fish.style.oTransform = 'rotate(' + deg + 'deg)';
        fish.style.transform = 'rotate(' + deg + 'deg)';
      }
    },
    scrollContent: function scrollContent() {
      var offset = 60;
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach(function (item) {
        if (item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset) if (item.dataset.header) document.querySelector('.header-nav').dataset.color = item.dataset.header;else document.querySelector('.header-nav').dataset.color = 'white';
      });
    },
    handleArrow: function handleArrow() {
      if (document.body.scrollTop > 200) {
        this.showArrow = false;
      }
      if (document.body.scrollTop === 0) this.showArrow = true;
    },
    doArrow: function doArrow() {
      __WEBPACK_IMPORTED_MODULE_3__js_scripts_js__["a" /* default */].scrollTo2('#promises', 600);
    },
    loadContent: function loadContent() {
      this.title[localStorage.getItem('language')] = this.title[localStorage.getItem('language')];
      this.$emit('updateHead');
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__js_scripts_js__["a" /* default */].addArrows();
    window.addEventListener('scroll', this.scrollContent);
    window.addEventListener('scroll', this.handleArrow);

    if (this.isTouch) return false;

    var sea = document.getElementById('sea');
    this.fishSchool = document.getElementsByClassName('fish');
    var scope = this;

    sea.onmousemove = function (e) {
      var x = e.pageX;
      var y = e.pageY;
      scope.updateFishScholl(x, y);
    };
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.scrollContent);
    window.removeEventListener('scroll', this.handleArrow);
  }
};

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Index',
  components: {
    FooterApp: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a
  },
  data: function data() {
    return {
      title: {
        en: 'A Campaign by Natura and PPC',
        es: 'Una Campaña de Natura y PPC'
      },
      description: {
        en: 'Plastic Kills is a campaign by Natura and Plastic Pollution Coalition to raise awareness about plastic pollution. Learn how to say NO to single-use plastic!',
        es: 'Plastic Kills es una campaña de Natura y Plastic Pollution Coalition para concienciar sobre la polución plástica. Aprende a decir NO al plástico desechable.'
      },
      showArrow: true,
      first: {},
      observer: false,
      blue_slider: {},
      green_slider: {},
      greenActive: 0,
      swiperOption: {
        notNextTick: true,
        loop: true,
        updateTranslate: true,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        observeParents: true,
        debugger: true,
        speed: 600,
        autoplay: 0,
        paginationClickable: false,
        onSlideChangeStart: function onSlideChangeStart(s) {
          if (__WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].isTouch()) {
            var activeSlideHeight = s.slides[s.activeIndex].querySelector('.full-inner').getBoundingClientRect().height + 'px';
            s.container[0].style.height = activeSlideHeight;
            if (__WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].get_viewport().width > 560) {
              s.container[0].style.minHeight = '100vh';
            }
          }
        }
      }
    };
  },

  head: {
    title: function title() {
      return {
        inner: this.title[localStorage.getItem('language')]
      };
    },
    meta: function meta() {
      return [{ name: 'description', content: 'Descripcion de Soluciones' }, { name: 'twitter:title', content: this.title[localStorage.getItem('language')] }, { name: 'twitter:descripcion', content: this.description[localStorage.getItem('language')] }];
    },
    link: function link() {
      return [{ rel: 'canonical', href: window.location.href }];
    }
  },
  computed: {
    blueSwiper: function blueSwiper() {
      return this.$refs.blueSwiper.swiper;
    },
    greenSwiper: function greenSwiper() {
      return this.$refs.greenSwiper.swiper;
    }
  },
  methods: {
    getUrl: function getUrl() {
      if (localStorage.getItem('language') === 'en') {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=home-page';
      } else {
        return "http://plastickills.es/site" + '/wp-json/wp/v2/pages?slug=pagina-de-inicio&lang=es';
      }
    },
    loadContent: function loadContent() {
      var _this = this;

      var getUrl = this.getUrl();

      this.axios.request({
        method: 'GET',
        url: this.getUrl()
      }).then(function (response) {
        var page = response.data[0];
        _this.first = {
          title: page.acf.first_home_title,
          content: page.acf.first_home_content,
          link_title: page.acf.first_home_link,
          link_url: page.acf.first_home_link_url
        };
        _this.blue_slider = {
          title: page.acf.blue_title,
          content: page.acf.blue_content,
          link_title: page.acf.blue_link_content,
          link_url: page.acf.blue_link_url
        };
        _this.green_slider = {
          title: page.acf.green_title,
          content: page.acf.green_content,
          link_title: page.acf.green_link,
          link_url: page.acf.green_link_url
        };
        _this.$nextTick(function () {
          _this.observeGreen();
          __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].addArrows();
        });
      });
    },
    observeGreen: function observeGreen() {
      var _this2 = this;

      if (this.$refs.greenSwiper === undefined || this.$refs.greenSwiper.swiper === undefined) {
        console.log('exiting');
        return false;
      }

      var green = this.$refs.greenSwiper.swiper.container[0].querySelector('.swiper-wrapper');
      this.observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'style') {
            _this2.greenActive = _this2.$refs.greenSwiper.swiper.realIndex;
          }
        });
      });
      this.observer.observe(green, {
        attributes: true
      });
    },
    scrollContent: function scrollContent() {
      var offset = 60;
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach(function (item, index) {
        if (item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset) if (item.dataset.header) document.querySelector('.header-nav').dataset.color = item.dataset.header;else document.querySelector('.header-nav').dataset.color = 'white';
        if (document.querySelectorAll('.wrapper-padding-bottom .span-full').length === index + 1 && item.getBoundingClientRect().bottom < 0) {
          document.querySelector('.header-nav').dataset.color = 'white';
        }
      });
    },
    doArrow: function doArrow() {
      __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].scrollTo2('#say-no', 600);
    },
    reloadContent: function reloadContent() {
      var _this3 = this;

      this.observer.disconnect();
      this.$nextTick(function () {
        _this3.loadContent();
      });
    }
  },
  watch: {
    '$route': 'reloadContent'
  },
  created: function created() {
    this.loadContent();
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.scrollContent);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__js_scripts_js__["a" /* default */].removeArrows();
    window.removeEventListener('scroll', this.scrollContent);
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = {
	initBubbles: function initBubbles() {

		var canvas = document.getElementById('bubbles');
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
		var ctx = canvas.getContext('2d');
		var bubbles = [];
		var t = 0;

		for (var i = 0; i < 5; i++) {
			bubbles[i] = blowBubble();
		}

		function resizeCanvas() {
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		}

		function blowBubble() {
			var bubble = [];
			bubble[0] = parseInt(Math.random() * 40 + 20);
			bubble[1] = parseInt(Math.random() * canvas.width);
			bubble[2] = canvas.height + bubble[0] * 2;
			bubble[3] = Math.random() * 5 + 1;
			return bubble;
		}

		function moveBubbles() {
			canvas.width = canvas.width;
			for (var i = 0; i < bubbles.length; i++) {
				ctx.beginPath();
				ctx.arc(bubbles[i][1], bubbles[i][2], bubbles[i][0], 0, 2 * Math.PI, false);
				ctx.fillStyle = "rgba(255, 255, 255, 0.75)";
				ctx.fill();
				bubbles[i][2] -= bubbles[i][3];
				if (bubbles[i][2] < bubbles[i][0] * -2) {
					bubbles[i] = blowBubble();
				}
			}
			requestAnimFrame(moveBubbles);
		}

		window.requestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (moveBubbles) {
			window.setTimeout(moveBubbles, 1000 / 60);
		};

		window.addEventListener('resize', resizeCanvas, false);

		moveBubbles();
	},
	parallax: function parallax() {
		var scene = document.getElementById('scene');
		var parallax = new Parallax(scene);
	}
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = {
  initSpace: function initSpace() {
    var canvas;
    var context;
    var screenH;
    var screenW;
    var stars = [];
    var fps = 50;
    var numStars = 2000;

    screenW = window.innerWidth;
    screenH = window.innerHeight;

    canvas = document.getElementById('starsCanvas');

    canvas.width = screenW;
    canvas.height = screenH;
    context = canvas.getContext('2d');

    function redraw() {
      stars = [];
      for (var i = 0; i < numStars; i++) {
        var x = Math.round(Math.random() * screenW);
        var y = Math.round(Math.random() * screenH);
        var length = 1 + Math.random() * 2;
        var opacity = Math.random();

        var star = new Star(x, y, length, opacity);

        stars.push(star);
      }
    }

    setInterval(animate, 1000 / fps);

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      redraw();
    }
    window.addEventListener('resize', resizeCanvas, false);
    redraw();

    function animate() {
      context.clearRect(0, 0, screenW, screenH);
      stars.forEach(function (star) {
        star.draw(context);
      });
    }

    function Star(x, y, length, opacity) {
      this.x = parseInt(x);
      this.y = parseInt(y);
      this.length = parseInt(length);
      this.opacity = opacity;
      this.factor = 1;
      this.increment = Math.random() * .03;
    }

    Star.prototype.draw = function () {
      context.rotate(Math.PI * 1 / 10);

      context.save();

      context.translate(this.x, this.y);

      if (this.opacity > 1) {
        this.factor = -1;
      } else if (this.opacity <= 0) {
        this.factor = 1;

        this.x = Math.round(Math.random() * screenW);
        this.y = Math.round(Math.random() * screenH);
      }

      this.opacity += this.increment * this.factor;

      context.beginPath();
      for (var i = 4; i--;) {
        context.lineTo(0, this.length);
        context.translate(0, this.length);
        context.rotate(Math.PI * 2 / 8);
        context.lineTo(0, -this.length);
        context.translate(0, -this.length);
        context.rotate(-(Math.PI * 6 / 8));
      }
      context.lineTo(0, this.length);
      context.closePath();
      context.fillStyle = "rgba(255, 255, 255, " + this.opacity + ")";
      context.shadowBlur = 5;
      context.fill();

      context.restore();
    };
  },
  initPoints: function initPoints() {
    var mapImageRealWidth = 1150;
    var mapImageRealHeight = 700;
    var planetMarkers = document.getElementsByClassName('planet-markers');
    var i = 0;
    var j = 0;

    for (i = 0; i < planetMarkers.length; i++) {
      var localMarkers = planetMarkers[i];
      var localPoints = localMarkers.getElementsByTagName('a');
      for (j = 0; j < localPoints.length; j++) {
        localPoints[j].style.left = 100 * localPoints[j].dataset.x / mapImageRealWidth + '%';
        localPoints[j].style.top = 100 * localPoints[j].dataset.y / mapImageRealHeight + '%';
      }
    }
  }
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

!function (t, i, e) {
  "use strict";
  function s(t, i) {
    this.element = t, this.layers = t.getElementsByClassName("layer");var e = { calibrateX: this.data(this.element, "calibrate-x"), calibrateY: this.data(this.element, "calibrate-y"), invertX: this.data(this.element, "invert-x"), invertY: this.data(this.element, "invert-y"), limitX: this.data(this.element, "limit-x"), limitY: this.data(this.element, "limit-y"), scalarX: this.data(this.element, "scalar-x"), scalarY: this.data(this.element, "scalar-y"), frictionX: this.data(this.element, "friction-x"), frictionY: this.data(this.element, "friction-y"), originX: this.data(this.element, "origin-x"), originY: this.data(this.element, "origin-y"), pointerEvents: this.data(this.element, "pointer-events"), precision: this.data(this.element, "precision") };for (var s in e) {
      null === e[s] && delete e[s];
    }this.extend(this, r, i, e), this.calibrationTimer = null, this.calibrationFlag = !0, this.enabled = !1, this.depthsX = [], this.depthsY = [], this.raf = null, this.bounds = null, this.ex = 0, this.ey = 0, this.ew = 0, this.eh = 0, this.ecx = 0, this.ecy = 0, this.erx = 0, this.ery = 0, this.cx = 0, this.cy = 0, this.ix = 0, this.iy = 0, this.mx = 0, this.my = 0, this.vx = 0, this.vy = 0, this.onMouseMove = this.onMouseMove.bind(this), this.onDeviceOrientation = this.onDeviceOrientation.bind(this), this.onOrientationTimer = this.onOrientationTimer.bind(this), this.onCalibrationTimer = this.onCalibrationTimer.bind(this), this.onAnimationFrame = this.onAnimationFrame.bind(this), this.onWindowResize = this.onWindowResize.bind(this), this.initialise();
  }var o = "Parallax",
      n = 30,
      r = { relativeInput: !1, clipRelativeInput: !1, calibrationThreshold: 100, calibrationDelay: 500, supportDelay: 500, calibrateX: !1, calibrateY: !0, invertX: !0, invertY: !0, limitX: !1, limitY: !1, scalarX: 10, scalarY: 10, frictionX: .1, frictionY: .1, originX: .5, originY: .5, pointerEvents: !0, precision: 1 };s.prototype.extend = function () {
    if (arguments.length > 1) for (var t = arguments[0], i = 1, e = arguments.length; e > i; i++) {
      var s = arguments[i];for (var o in s) {
        t[o] = s[o];
      }
    }
  }, s.prototype.data = function (t, i) {
    return this.deserialize(t.getAttribute("data-" + i));
  }, s.prototype.deserialize = function (t) {
    return "true" === t ? !0 : "false" === t ? !1 : "null" === t ? null : !isNaN(parseFloat(t)) && isFinite(t) ? parseFloat(t) : t;
  }, s.prototype.camelCase = function (t) {
    return t.replace(/-+(.)?/g, function (t, i) {
      return i ? i.toUpperCase() : "";
    });
  }, s.prototype.transformSupport = function (s) {
    for (var o = i.createElement("div"), n = !1, r = null, a = !1, h = null, l = null, p = 0, m = this.vendors.length; m > p; p++) {
      if (null !== this.vendors[p] ? (h = this.vendors[p][0] + "transform", l = this.vendors[p][1] + "Transform") : (h = "transform", l = "transform"), o.style[l] !== e) {
        n = !0;break;
      }
    }switch (s) {case "2D":
        a = n;break;case "3D":
        if (n) {
          var c = i.body || i.createElement("body"),
              u = i.documentElement,
              y = u.style.overflow,
              d = !1;i.body || (d = !0, u.style.overflow = "hidden", u.appendChild(c), c.style.overflow = "hidden", c.style.background = ""), c.appendChild(o), o.style[l] = "translate3d(1px,1px,1px)", r = t.getComputedStyle(o).getPropertyValue(h), a = r !== e && r.length > 0 && "none" !== r, u.style.overflow = y, c.removeChild(o), d && (c.removeAttribute("style"), c.parentNode.removeChild(c));
        }}return a;
  }, s.prototype.ww = null, s.prototype.wh = null, s.prototype.wcx = null, s.prototype.wcy = null, s.prototype.wrx = null, s.prototype.wry = null, s.prototype.portrait = null, s.prototype.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i), s.prototype.vendors = [null, ["-webkit-", "webkit"], ["-moz-", "Moz"], ["-o-", "O"], ["-ms-", "ms"]], s.prototype.motionSupport = !!t.DeviceMotionEvent, s.prototype.orientationSupport = !!t.DeviceOrientationEvent, s.prototype.orientationStatus = 0, s.prototype.motionStatus = 0, s.prototype.propertyCache = {}, s.prototype.initialise = function () {
    s.prototype.transform2DSupport === e && (s.prototype.transform2DSupport = s.prototype.transformSupport("2D"), s.prototype.transform3DSupport = s.prototype.transformSupport("3D")), this.transform3DSupport && this.accelerate(this.element);var i = t.getComputedStyle(this.element);"static" === i.getPropertyValue("position") && (this.element.style.position = "relative"), this.pointerEvents || (this.element.style.pointerEvents = "none"), this.updateLayers(), this.updateDimensions(), this.enable(), this.queueCalibration(this.calibrationDelay);
  }, s.prototype.updateLayers = function () {
    this.layers = this.element.getElementsByClassName("layer"), this.depthsX = [], this.depthsY = [];for (var t = 0, i = this.layers.length; i > t; t++) {
      var e = this.layers[t];this.transform3DSupport && this.accelerate(e), e.style.position = t ? "absolute" : "relative", e.style.display = "block", e.style.left = 0, e.style.top = 0;var s = this.data(e, "depth") || 0;this.depthsX.push(this.data(e, "depth-x") || s), this.depthsY.push(this.data(e, "depth-y") || s);
    }
  }, s.prototype.updateDimensions = function () {
    this.ww = t.innerWidth, this.wh = t.innerHeight, this.wcx = this.ww * this.originX, this.wcy = this.wh * this.originY, this.wrx = Math.max(this.wcx, this.ww - this.wcx), this.wry = Math.max(this.wcy, this.wh - this.wcy);
  }, s.prototype.updateBounds = function () {
    this.bounds = this.element.getBoundingClientRect(), this.ex = this.bounds.left, this.ey = this.bounds.top, this.ew = this.bounds.width, this.eh = this.bounds.height, this.ecx = this.ew * this.originX, this.ecy = this.eh * this.originY, this.erx = Math.max(this.ecx, this.ew - this.ecx), this.ery = Math.max(this.ecy, this.eh - this.ecy);
  }, s.prototype.queueCalibration = function (t) {
    clearTimeout(this.calibrationTimer), this.calibrationTimer = setTimeout(this.onCalibrationTimer, t);
  }, s.prototype.enable = function () {
    this.enabled || (this.enabled = !0, !this.desktop && this.orientationSupport ? (this.portrait = null, t.addEventListener("deviceorientation", this.onDeviceOrientation), setTimeout(this.onOrientationTimer, this.supportDelay)) : !this.desktop && this.motionSupport ? (this.portrait = null, t.addEventListener("devicemotion", this.onDeviceMotion), setTimeout(this.onMotionTimer, this.supportDelay)) : (this.cx = 0, this.cy = 0, this.portrait = !1, t.addEventListener("mousemove", this.onMouseMove)), t.addEventListener("resize", this.onWindowResize), this.raf = requestAnimationFrame(this.onAnimationFrame));
  }, s.prototype.disable = function () {
    this.enabled && (this.enabled = !1, this.orientationSupport ? t.removeEventListener("deviceorientation", this.onDeviceOrientation) : this.motionSupport ? t.removeEventListener("devicemotion", this.onDeviceMotion) : t.removeEventListener("mousemove", this.onMouseMove), t.removeEventListener("resize", this.onWindowResize), cancelAnimationFrame(this.raf));
  }, s.prototype.calibrate = function (t, i) {
    this.calibrateX = t === e ? this.calibrateX : t, this.calibrateY = i === e ? this.calibrateY : i;
  }, s.prototype.invert = function (t, i) {
    this.invertX = t === e ? this.invertX : t, this.invertY = i === e ? this.invertY : i;
  }, s.prototype.friction = function (t, i) {
    this.frictionX = t === e ? this.frictionX : t, this.frictionY = i === e ? this.frictionY : i;
  }, s.prototype.scalar = function (t, i) {
    this.scalarX = t === e ? this.scalarX : t, this.scalarY = i === e ? this.scalarY : i;
  }, s.prototype.limit = function (t, i) {
    this.limitX = t === e ? this.limitX : t, this.limitY = i === e ? this.limitY : i;
  }, s.prototype.origin = function (t, i) {
    this.originX = t === e ? this.originX : t, this.originY = i === e ? this.originY : i;
  }, s.prototype.clamp = function (t, i, e) {
    return t = Math.max(t, i), t = Math.min(t, e);
  }, s.prototype.css = function (t, i, s) {
    var o = this.propertyCache[i];if (!o) for (var n = 0, r = this.vendors.length; r > n; n++) {
      if (o = null !== this.vendors[n] ? this.camelCase(this.vendors[n][1] + "-" + i) : i, t.style[o] !== e) {
        this.propertyCache[i] = o;break;
      }
    }t.style[o] = s;
  }, s.prototype.accelerate = function (t) {
    this.css(t, "transform", "translate3d(0,0,0)"), this.css(t, "transform-style", "preserve-3d"), this.css(t, "backface-visibility", "hidden");
  }, s.prototype.setPosition = function (t, i, e) {
    i = i.toFixed(this.precision) + "px", e = e.toFixed(this.precision) + "px", this.transform3DSupport ? this.css(t, "transform", "translate3d(" + i + "," + e + ",0)") : this.transform2DSupport ? this.css(t, "transform", "translate(" + i + "," + e + ")") : (t.style.left = i, t.style.top = e);
  }, s.prototype.onOrientationTimer = function () {
    this.orientationSupport && 0 === this.orientationStatus && (this.disable(), this.orientationSupport = !1, this.enable());
  }, s.prototype.onMotionTimer = function () {
    this.motionSupport && 0 === this.motionStatus && (this.disable(), this.motionSupport = !1, this.enable());
  }, s.prototype.onCalibrationTimer = function () {
    this.calibrationFlag = !0;
  }, s.prototype.onWindowResize = function () {
    this.updateDimensions();
  }, s.prototype.onAnimationFrame = function () {
    this.updateBounds();var t = this.ix - this.cx,
        i = this.iy - this.cy;(Math.abs(t) > this.calibrationThreshold || Math.abs(i) > this.calibrationThreshold) && this.queueCalibration(0), this.portrait ? (this.mx = this.calibrateX ? i : this.iy, this.my = this.calibrateY ? t : this.ix) : (this.mx = this.calibrateX ? t : this.ix, this.my = this.calibrateY ? i : this.iy), this.mx *= this.ew * (this.scalarX / 100), this.my *= this.eh * (this.scalarY / 100), isNaN(parseFloat(this.limitX)) || (this.mx = this.clamp(this.mx, -this.limitX, this.limitX)), isNaN(parseFloat(this.limitY)) || (this.my = this.clamp(this.my, -this.limitY, this.limitY)), this.vx += (this.mx - this.vx) * this.frictionX, this.vy += (this.my - this.vy) * this.frictionY;for (var e = 0, s = this.layers.length; s > e; e++) {
      var o = this.layers[e],
          n = this.depthsX[e],
          r = this.depthsY[e],
          a = this.vx * (n * (this.invertX ? -1 : 1)),
          h = this.vy * (r * (this.invertY ? -1 : 1));this.setPosition(o, a, h);
    }this.raf = requestAnimationFrame(this.onAnimationFrame);
  }, s.prototype.rotate = function (t, i) {
    var e = (event.beta || 0) / n,
        s = (event.gamma || 0) / n,
        o = this.wh > this.ww;this.portrait !== o && (this.portrait = o, this.calibrationFlag = !0), this.calibrationFlag && (this.calibrationFlag = !1, this.cx = e, this.cy = s), this.ix = e, this.iy = s;
  }, s.prototype.onDeviceOrientation = function (t) {
    var i = t.beta,
        e = t.gamma;this.desktop || null === i || null === e || (this.orientationStatus = 1, this.rotate(i, e));
  }, s.prototype.onDeviceMotion = function (t) {
    var i = t.rotationRate.beta,
        e = t.rotationRate.gamma;this.desktop || null === i || null === e || (this.motionStatus = 1, this.rotate(i, e));
  }, s.prototype.onMouseMove = function (t) {
    var i = t.clientX,
        e = t.clientY;!this.orientationSupport && this.relativeInput ? (this.clipRelativeInput && (i = Math.max(i, this.ex), i = Math.min(i, this.ex + this.ew), e = Math.max(e, this.ey), e = Math.min(e, this.ey + this.eh)), this.ix = (i - this.ex - this.ecx) / this.erx, this.iy = (e - this.ey - this.ecy) / this.ery) : (this.ix = (i - this.wcx) / this.wrx, this.iy = (e - this.wcy) / this.wry);
  }, t[o] = s;
}(window, document), function () {
  for (var t = 0, i = ["ms", "moz", "webkit", "o"], e = 0; e < i.length && !window.requestAnimationFrame; ++e) {
    window.requestAnimationFrame = window[i[e] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[e] + "CancelAnimationFrame"] || window[i[e] + "CancelRequestAnimationFrame"];
  }window.requestAnimationFrame || (window.requestAnimationFrame = function (i, e) {
    var s = new Date().getTime(),
        o = Math.max(0, 16 - (s - t)),
        n = window.setTimeout(function () {
      i(s + o);
    }, o);return t = s + o, n;
  }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (t) {
    clearTimeout(t);
  });
}();

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper black",
    class: {
      'active': _vm.isMenuActive
    }
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.lang
      }
    }
  }, [_vm._v("Plastic Kills")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-trigger"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isMenuActive = !_vm.isMenuActive
      }
    }
  }, [_c('span')])]), _vm._v(" "), (_vm.isMenuActive) ? _c('div', {
    staticClass: "lang white"
  }, [_c('ul', {
    staticClass: "ul-horz"
  }, [(_vm.lang === 'es') ? _c('li', [_c('a', {
    staticClass: "title-font",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.lang = 'en'
      }
    }
  }, [_vm._v("English")])]) : _vm._e(), _vm._v(" "), (_vm.lang === 'en') ? _c('li', [_c('a', {
    staticClass: "title-font",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.lang = 'es'
      }
    }
  }, [_vm._v("Español")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMenuActive),
      expression: "isMenuActive"
    }],
    staticClass: "header-menu-wrapper"
  }, [_c('div', {
    staticClass: "span-full span-3 white"
  }, [_c('div', {
    staticClass: "item table-wrap"
  }, [_c('router-link', {
    staticClass: "table-cell",
    attrs: {
      "to": {
        name: 'Problems',
        params: {
          'lang': _vm.lang
        }
      }
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('div', {
    staticClass: "item-bg",
    staticStyle: {
      "background-image": "url('/static/images/menu-bag2.jpg')"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.problems[_vm.lang]))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item table-wrap"
  }, [_c('router-link', {
    staticClass: "table-cell",
    attrs: {
      "to": {
        name: 'Solutions',
        params: {
          'lang': _vm.lang
        }
      }
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('div', {
    staticClass: "item-bg",
    staticStyle: {
      "background-image": "url('/static/images/menu-bottle2.jpg')"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.solutions[_vm.lang]))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item table-wrap"
  }, [_c('a', {
    staticClass: "table-cell",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goFooter($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-bg",
    staticStyle: {
      "background-image": "url('/static/images/menu-seal2.jpg')"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.joinUs[_vm.lang]))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "wrapper-padding-bottom"
  }, [(!_vm.isTouch) ? _c('div', {
    staticClass: "span-full bgblue",
    attrs: {
      "data-type": "layout"
    }
  }, [_c('div', {
    staticClass: "full-inner",
    attrs: {
      "id": "sea"
    }
  }, _vm._l((_vm.fishSchoolData), function(fish, index) {
    return _c('div', {
      staticClass: "fish",
      class: fish.color,
      style: ({
        left: fish.x,
        top: fish.y
      })
    })
  })), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isTouch) ? _c('div', {
    staticClass: "span-full bgblue"
  }, [_c('div', {
    staticClass: "full-inner",
    attrs: {
      "id": "sea-responsive"
    }
  }, [_c('img', {
    attrs: {
      "src": '/static/images/solutions-responsive-hero.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    staticClass: "read-more"
  }, [_c('icon', {
    attrs: {
      "name": "customangledown",
      "scale": "2.5"
    }
  })], 1)]), _vm._v(" "), _vm._m(1)], 1) : _vm._e(), _vm._v(" "), _c('solutions-promises'), _vm._v(" "), _c('solutions-tips')], 1), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wrapper span-full bgblack",
    staticStyle: {
      "background-image": "url('/static/images/footer-bg.jpg')"
    },
    attrs: {
      "id": "contact",
      "data-type": "layout"
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticClass: "content-750"
  }, [_c('h3', [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }), _vm._v(" "), _c('contact')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-credits pb2"
  }, [_c('div', {
    staticClass: "span-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Natura — All Rights Reserved " + _vm._s(_vm.year))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.footer.email
    }
  }, [_vm._v(_vm._s(_vm.footer.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "item text-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.footer.instagram,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.footer.facebook,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.footer.twitter,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item text-left"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "//www.naturaselection.com/"
    }
  }, [_c('img', {
    staticClass: "pr1",
    attrs: {
      "src": "/static/images/footer-credits-naturaplastickill-1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//www.plasticpollutioncoalition.org/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-credits-naturaplastickill-2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Designed by "), _c('a', {
    attrs: {
      "href": "http://septimo.co/",
      "target": "_blank"
    }
  }, [_vm._v("Séptimo Studio")])])])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon) ? _c('path', {
    attrs: {
      "d": _vm.icon.d
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full bgwhite black",
    style: ({
      transformStyle: (_vm.isDialogActive ? 'flat' : 'preserve-3d')
    }),
    attrs: {
      "id": "promises",
      "data-type": "layout",
      "data-header": "green"
    }
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('h3', {
    staticClass: "mt3",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-green mt3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openDialog($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.page.callToAction))])]), _vm._v(" "), (_vm.isDialogActive) ? _c('div', {
    staticClass: "span-dialogs-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "simple-fade"
    }
  }, [(_vm.isDialogListActive) ? _c('div', {
    staticClass: "span-dialogs span-full"
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('div', {
    staticClass: "item-dialog item-dialog-single pt3 pb3 content-500",
    class: 'bg' + _vm.activeDialog.background_color
  }, [_c('h3', {
    staticClass: "uppercase pl3 pr3 pb1"
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.activeDialog.content))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-white white mt1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNext($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeDialog.trigger))])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "simple-fade-confirmation"
    }
  }, [(_vm.isConfirmationActive) ? _c('div', {
    key: 'confirmation',
    staticClass: "span-confirmation span-full"
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('div', {
    staticClass: "item-dialog item-dialog-confirmation pt3 pb3 content-750 bgblue"
  }, [_c('h2', [_vm._v(_vm._s(_vm.confirmation.title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pl3 pr3 pt2 pl5 pr5"
  }, [_c('p', {
    staticClass: "title-font"
  }, [_vm._v(_vm._s(_vm.confirmation.content))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-white mt2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeConfirmation($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmation.close))])])])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more green",
    attrs: {
      "href": "#",
      "data-index": "1"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "swiper-ocean-container",
      "data-type": "layout"
    }
  }, [_c('swiper', {
    ref: "problemsOcean",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bgblue",
    attrs: {
      "id": "swiper-ocean",
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "full-title content-650"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner content-750"
  }, [_c('h3', {
    staticClass: "full-title white"
  }, [_vm._v(_vm._s(_vm.slider[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3",
    domProps: {
      "innerHTML": _vm._s(_vm.slider[0].content)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner content-750"
  }, [_c('h3', {
    staticClass: "full-title white"
  }, [_vm._v(_vm._s(_vm.slider[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3",
    domProps: {
      "innerHTML": _vm._s(_vm.slider[1].content)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "scene",
    attrs: {
      "id": "scene",
      "data-friction-x": "0.1",
      "data-friction-y": "0.1",
      "data-scalar-x": "4"
    }
  }, [_c('li', {
    staticClass: "layer turtle",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-turtle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish1",
    attrs: {
      "data-depth": "-0.50"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish1.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bottle",
    attrs: {
      "data-depth": "0.40"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-bottle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish2",
    attrs: {
      "data-depth": "0.60"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish2.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish3",
    attrs: {
      "data-depth": "0.80"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish3.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bag",
    attrs: {
      "data-depth": "-0.90"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-bag.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fork",
    attrs: {
      "data-depth": "0.70"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fork.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish4",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish3.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish5",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish1.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish6",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish4.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish7",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish5.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bottle2",
    attrs: {
      "data-depth": "0.40"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-bottle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bottle3",
    attrs: {
      "data-depth": "-0.40"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-bottle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fork2",
    attrs: {
      "data-depth": "0.70"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fork.svg"
    }
  })])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "bubbles"
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "1"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "wrapper-padding-bottom"
  }, [_vm._m(0), _vm._v(" "), (_vm.first.title) ? _c('div', {
    staticClass: "span-full bgwhite",
    attrs: {
      "data-type": "layout",
      "id": "say-no",
      "data-header": "green"
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('h2', {
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.first.title))]), _vm._v(" "), _c('div', {
    staticClass: "content-960 black mt3"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.first.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-btn"
  }, [(_vm.first.link_title) ? _c('a', {
    staticClass: "btn btn-green mt3",
    attrs: {
      "href": _vm.first.link_url
    }
  }, [_vm._v(_vm._s(_vm.first.link_title))]) : _vm._e()])])])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "data-type": "layout"
    }
  }, [(_vm.blue_slider.title) ? _c('swiper', {
    ref: "blueSwiper",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bgblue",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "white",
    domProps: {
      "innerHTML": _vm._s(_vm.blue_slider.title)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h3', {
    staticClass: "white no-br content-500",
    domProps: {
      "innerHTML": _vm._s(_vm.blue_slider.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3 content-750",
    domProps: {
      "innerHTML": _vm._s(_vm.blue_slider.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-btn"
  }, [(_vm.blue_slider.link_title) ? _c('a', {
    staticClass: "btn btn-white mt3",
    attrs: {
      "href": _vm.blue_slider.link_url
    }
  }, [_vm._v(_vm._s(_vm.blue_slider.link_title))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "data-type": "layout"
    }
  }, [(_vm.green_slider.title) ? _c('swiper', {
    ref: "greenSwiper",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bggreen",
    attrs: {
      "id": 'green-swiper',
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "white",
    domProps: {
      "innerHTML": _vm._s(_vm.green_slider.title)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h3', {
    staticClass: "white no-br",
    domProps: {
      "innerHTML": _vm._s(_vm.green_slider.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3 content-750",
    domProps: {
      "innerHTML": _vm._s(_vm.green_slider.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-btn"
  }, [(_vm.green_slider.link_title) ? _c('a', {
    staticClass: "btn btn-white mt3",
    attrs: {
      "href": _vm.green_slider.link_url
    }
  }, [_vm._v(_vm._s(_vm.green_slider.link_title))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.greenActive === 1),
      expression: "greenActive === 1"
    }],
    staticClass: "full-bottom-logo",
    attrs: {
      "target": "_blank",
      "href": "//www.plasticpollutioncoalition.org/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-credits-naturaplastickill-2.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full span-full-bg bgblue relative",
    staticStyle: {
      "background-image": "url('/static/images/home-bg.png')"
    },
    attrs: {
      "data-type": "layout"
    }
  }, [_c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more green",
    attrs: {
      "href": "#",
      "data-index": "1"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "2"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "3"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-type": "layout"
    }
  }, [_c('swiper', {
    ref: "problemsPlasticKills",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bgorange",
    attrs: {
      "id": "swiper-plastickill",
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "full-title content-650"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _vm._l((_vm.slider), function(item, key) {
    return (item.title) ? _c('swiper-slide', [_c('div', {
      staticClass: "full-inner"
    }, [_c('div', {
      staticClass: "span-table text-left"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "content-650"
    }, [_c('h2', {
      staticClass: "full-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "entry-content pt1 content-500 left",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "item item-image full-image"
    }, [_c('img', {
      staticClass: "icon-slider",
      class: 'plastickills-' + key,
      attrs: {
        "src": '/static/images/whyplastic-slider-' + key + '.png',
        "alt": ""
      }
    })])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "2"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full bgdarkblue black",
    attrs: {
      "id": "space",
      "data-type": "layout"
    }
  }, [_c('canvas', {
    staticClass: "bgdarkblue",
    attrs: {
      "id": "starsCanvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-inner"
  }, [_c('h3', {
    staticClass: "pb6",
    domProps: {
      "innerHTML": _vm._s(_vm.page.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "planet-wrapper mt5 relative"
  }, [_c('div', {
    attrs: {
      "id": "stars"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "simple-fade"
    }
  }, [(_vm.isPopupActive) ? _c('div', {
    staticClass: "item-dialog item-dialog-single no-border pt2 pb2 content-500 bgblack",
    attrs: {
      "id": "planet-popup"
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.popupTitle))]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "entry-content"
  }, [_vm._v("\n              " + _vm._s(_vm.popupText) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "planet"
  }, [_c('div', {
    attrs: {
      "id": "planet-markers-container"
    }
  }, _vm._l((3), function(n) {
    return _c('div', {
      staticClass: "planet-markers"
    }, _vm._l((_vm.points), function(point, index) {
      return _c('a', {
        attrs: {
          "data-x": point.x,
          "data-y": point.y,
          "data-name": point.name,
          "data-text": point.text
        },
        on: {
          "click": function($event) {
            _vm.showPopup(index)
          }
        }
      })
    }))
  }))]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ovni"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "satellite"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cloud-wrapper"
  }, [_c('div', {
    staticClass: "cloud icon-cloud-right cloud-top-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-centred cloud-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-right cloud-middle-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-centred cloud-bottom-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-left cloud-bottom-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "comets"
    }
  }, [_c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "wrapper-padding-bottom"
  }, [_c('problems-planet'), _vm._v(" "), _c('problems-ocean'), _vm._v(" "), _c('problems-plastickill'), _vm._v(" "), _c('problems-graph')], 1), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-app'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "content-form",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field field-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder.name[_vm.lang],
      "name": 'name'
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "focus": _vm.inputOnFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "field-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business),
      expression: "business"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder.business[_vm.lang],
      "name": 'business'
    },
    domProps: {
      "value": _vm._s(_vm.business)
    },
    on: {
      "focus": _vm.inputOnFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('business')),
      expression: "errors.has('business')"
    }],
    staticClass: "field-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first('business')))])]), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: true,
          email: true
        }
      }),
      expression: "{ rules: { required: true, email: true } }",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder.email[_vm.lang],
      "name": 'email'
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "focus": _vm.inputOnFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "field-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "field field-submit mt2"
  }, [_c('button', {
    staticClass: "btn btn-white"
  }, [_vm._v(_vm._s(_vm.placeholder.submit[_vm.lang]))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [(_vm.isSubmitted) ? _c('div', {
    staticClass: "field-result field-submitted mt2"
  }, [_vm._v(_vm._s(_vm.result.success[_vm.lang]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [(_vm.errors.any()) ? _c('div', {
    staticClass: "field-result field-errors mt2"
  }, [_vm._v(_vm._s(_vm.result.error[_vm.lang]))]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full bgwhite black",
    class: {
      'active': _vm.isActive
    },
    attrs: {
      "data-header": "green",
      "data-type": "layout",
      "id": "problems-graph"
    }
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('div', {
    staticClass: "span-table va-top text-left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "content-500"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.consumables.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph-list pt3"
  }, _vm._l((_vm.consumables.stats), function(item) {
    return _c('div', {
      staticClass: "field pb1"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.title) + " " + _vm._s(item.percentage + '%'))]), _vm._v(" "), _c('span', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "filled",
      style: ({
        width: (_vm.isActive ? parseFloat(item.percentage) + '%' : 0 + '%')
      })
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "content-500"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.residuals.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph-list pt3"
  }, _vm._l((_vm.residuals.stats), function(item) {
    return _c('div', {
      staticClass: "field pb1"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.title) + " " + _vm._s(item.percentage + '%'))]), _vm._v(" "), _c('span', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "filled",
      style: ({
        width: (_vm.isActive ? item.percentage + '%' : 0 + '%')
      })
    })])])
  }))])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center pt3"
  }, [_vm._v(_vm._s(_vm.credits))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more green",
    attrs: {
      "href": "#",
      "data-index": "3"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-tips span-full bgblack",
    attrs: {
      "id": "tips",
      "data-type": "layout"
    }
  }, [_c('div', {
    staticClass: "full-inner span-blocks span-3"
  }, _vm._l((_vm.tips), function(item, key) {
    return _c('div', {
      staticClass: "item figure",
      class: _vm.direction[Math.floor(Math.random() * _vm.direction.length)]
    }, [_c('div', {
      staticClass: "face flip item-content pl3 pr3",
      class: 'bg' + item.background_color
    }, [_c('h3', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "face flop item-bg",
      class: 'bg' + item.background_color
    }, [_c('div', {
      staticClass: "item-icon",
      class: 'icon-slider-' + parseInt(key)
    })])])
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "2"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_instagram__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_facebook__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_twitter__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_angle_down__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__locale_es__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__locale_en__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vee_validate__);















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('icon', __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue___default.a.register({
  customangledown: {
    width: 1792,
    height: 1792,
    d: 'M896,1381.9L0,485.9l75.8-75.8L896,1230.2l820.2-820.2l75.8,75.8L896,1381.9z'
  }
});




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_14_vee_validate__["Validator"].updateDictionary({
  es: { messages: __WEBPACK_IMPORTED_MODULE_12__locale_es__["a" /* default */] },
  en: { messages: __WEBPACK_IMPORTED_MODULE_13__locale_en__["a" /* default */] }
});


var css = __webpack_require__(53);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].afterEach(function (to, from, next) {
  if (document.querySelector('.header-wrapper').classList.contains('active')) document.querySelector('.header-wrapper .menu-trigger a').click();
});

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  if (typeof ga === 'function') {
    ga('send', {
      hitType: 'pageview',
      page: to.path,
      location: window.location.origin + to.fullPath,
      title: to.name
    });
  }
  next();
});

/***/ })
],[175]);


// WEBPACK FOOTER //
// static/js/app.954ffc8e2511e95fe765.js